export const VendorOrderStatus = {
  Unknown: 0,
  Accepted: 1,
  Rejected: 2,
};
